import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactPlayer from 'react-player';

const VideoSlider = ({ videos }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 0,
        },
      },
    ],
  };

  return (
    <div className="flex w-full">
      <div className="w-full bg-white">
        <Slider {...settings}>
          {videos?.length &&
            videos?.map((url, index) => {
              return (
                <div className="px-2 h-52" key={index}>
                  <ReactPlayer
                    className="react-player"
                    controls
                    url={url}
                    width="100%"
                    height="100%"
                  />
                </div>
              );
            })}
        </Slider>
      </div>
    </div>
  );
};

export default VideoSlider;
